export class FeeAdjustmentsModel {
  a: number = 0;
  b: number = 0;
  c: number = 0;
  decimalPlace: number;
  roundTo: number;
}
